/**
 * Generated from RestStopGameLayout.fla
 */
export function RestStopGameLayout(this: IRestStopGameLayout) {
	const barGraphPlusButton = this.barGraphPlusButton;
	if (!barGraphPlusButton[0] && barGraphPlusButton.elementFactory) {
		barGraphPlusButton[0] = barGraphPlusButton.elementFactory(0,undefined);
	}
	if (barGraphPlusButton[0]) {
		RestStopGameLayout_plusButton.call(barGraphPlusButton[0] as IRestStopGameLayout_plusButton);
		barGraphPlusButton[0].x = 710.9;
		barGraphPlusButton[0].y = 552.9;
		barGraphPlusButton[0].width = 62.00;
		barGraphPlusButton[0].height = 66.00;
		if (barGraphPlusButton[0].onLayout) barGraphPlusButton[0].onLayout();
	}
	if (!barGraphPlusButton[1] && barGraphPlusButton.elementFactory) {
		barGraphPlusButton[1] = barGraphPlusButton.elementFactory(1,undefined);
	}
	if (barGraphPlusButton[1]) {
		RestStopGameLayout_plusButton.call(barGraphPlusButton[1] as IRestStopGameLayout_plusButton);
		barGraphPlusButton[1].x = 812.4;
		barGraphPlusButton[1].y = 552.9;
		barGraphPlusButton[1].width = 62.00;
		barGraphPlusButton[1].height = 66.00;
		if (barGraphPlusButton[1].onLayout) barGraphPlusButton[1].onLayout();
	}
	if (!barGraphPlusButton[2] && barGraphPlusButton.elementFactory) {
		barGraphPlusButton[2] = barGraphPlusButton.elementFactory(2,undefined);
	}
	if (barGraphPlusButton[2]) {
		RestStopGameLayout_plusButton.call(barGraphPlusButton[2] as IRestStopGameLayout_plusButton);
		barGraphPlusButton[2].x = 912.4;
		barGraphPlusButton[2].y = 552.9;
		barGraphPlusButton[2].width = 62.00;
		barGraphPlusButton[2].height = 66.00;
		if (barGraphPlusButton[2].onLayout) barGraphPlusButton[2].onLayout();
	}
	const resourcesBarGraphBar = this.resourcesBarGraphBar;
	if (!resourcesBarGraphBar[0] && resourcesBarGraphBar.elementFactory) {
		resourcesBarGraphBar[0] = resourcesBarGraphBar.elementFactory(0,undefined);
	}
	if (resourcesBarGraphBar[0]) {
		RestStopGameLayout_resourcesBarGraphBar.call(resourcesBarGraphBar[0] as IRestStopGameLayout_resourcesBarGraphBar);
		resourcesBarGraphBar[0].x = 711.5;
		resourcesBarGraphBar[0].y = 471;
		resourcesBarGraphBar[0].width = 46.00;
		resourcesBarGraphBar[0].height = 53.50;
		if (resourcesBarGraphBar[0].onLayout) resourcesBarGraphBar[0].onLayout();
	}
	if (!resourcesBarGraphBar[1] && resourcesBarGraphBar.elementFactory) {
		resourcesBarGraphBar[1] = resourcesBarGraphBar.elementFactory(1,undefined);
	}
	if (resourcesBarGraphBar[1]) {
		RestStopGameLayout_resourcesBarGraphBar.call(resourcesBarGraphBar[1] as IRestStopGameLayout_resourcesBarGraphBar);
		resourcesBarGraphBar[1].x = 810;
		resourcesBarGraphBar[1].y = 471;
		resourcesBarGraphBar[1].width = 46.00;
		resourcesBarGraphBar[1].height = 53.50;
		if (resourcesBarGraphBar[1].onLayout) resourcesBarGraphBar[1].onLayout();
	}
	if (!resourcesBarGraphBar[2] && resourcesBarGraphBar.elementFactory) {
		resourcesBarGraphBar[2] = resourcesBarGraphBar.elementFactory(2,undefined);
	}
	if (resourcesBarGraphBar[2]) {
		RestStopGameLayout_resourcesBarGraphBar.call(resourcesBarGraphBar[2] as IRestStopGameLayout_resourcesBarGraphBar);
		resourcesBarGraphBar[2].x = 911.6;
		resourcesBarGraphBar[2].y = 471;
		resourcesBarGraphBar[2].width = 46.00;
		resourcesBarGraphBar[2].height = 53.50;
		if (resourcesBarGraphBar[2].onLayout) resourcesBarGraphBar[2].onLayout();
	}
	const stressorsBarGraphBar = this.stressorsBarGraphBar;
	if (!stressorsBarGraphBar[0] && stressorsBarGraphBar.elementFactory) {
		stressorsBarGraphBar[0] = stressorsBarGraphBar.elementFactory(0,undefined);
	}
	if (stressorsBarGraphBar[0]) {
		RestStopGameLayout_stressorsBarGraphBar.call(stressorsBarGraphBar[0] as IRestStopGameLayout_stressorsBarGraphBar);
		stressorsBarGraphBar[0].x = 711;
		stressorsBarGraphBar[0].y = 471;
		stressorsBarGraphBar[0].width = 46.00;
		stressorsBarGraphBar[0].height = 53.50;
		if (stressorsBarGraphBar[0].onLayout) stressorsBarGraphBar[0].onLayout();
	}
	if (!stressorsBarGraphBar[1] && stressorsBarGraphBar.elementFactory) {
		stressorsBarGraphBar[1] = stressorsBarGraphBar.elementFactory(1,undefined);
	}
	if (stressorsBarGraphBar[1]) {
		RestStopGameLayout_stressorsBarGraphBar.call(stressorsBarGraphBar[1] as IRestStopGameLayout_stressorsBarGraphBar);
		stressorsBarGraphBar[1].x = 809.5;
		stressorsBarGraphBar[1].y = 471;
		stressorsBarGraphBar[1].width = 46.00;
		stressorsBarGraphBar[1].height = 53.50;
		if (stressorsBarGraphBar[1].onLayout) stressorsBarGraphBar[1].onLayout();
	}
	if (!stressorsBarGraphBar[2] && stressorsBarGraphBar.elementFactory) {
		stressorsBarGraphBar[2] = stressorsBarGraphBar.elementFactory(2,undefined);
	}
	if (stressorsBarGraphBar[2]) {
		RestStopGameLayout_stressorsBarGraphBar.call(stressorsBarGraphBar[2] as IRestStopGameLayout_stressorsBarGraphBar);
		stressorsBarGraphBar[2].x = 911.1;
		stressorsBarGraphBar[2].y = 471;
		stressorsBarGraphBar[2].width = 46.00;
		stressorsBarGraphBar[2].height = 53.50;
		if (stressorsBarGraphBar[2].onLayout) stressorsBarGraphBar[2].onLayout();
	}
	const barGraphXAxisIcon = this.barGraphXAxisIcon;
	if (!barGraphXAxisIcon[0] && barGraphXAxisIcon.elementFactory) {
		barGraphXAxisIcon[0] = barGraphXAxisIcon.elementFactory(0,undefined);
	}
	if (barGraphXAxisIcon[0]) {
		RestStopGameLayout_barGraphXAxisIcon.call(barGraphXAxisIcon[0] as IRestStopGameLayout_barGraphXAxisIcon);
		barGraphXAxisIcon[0].x = 711;
		barGraphXAxisIcon[0].y = 494.4;
		barGraphXAxisIcon[0].width = 60.00;
		barGraphXAxisIcon[0].height = 44.00;
		if (barGraphXAxisIcon[0].onLayout) barGraphXAxisIcon[0].onLayout();
	}
	if (!barGraphXAxisIcon[1] && barGraphXAxisIcon.elementFactory) {
		barGraphXAxisIcon[1] = barGraphXAxisIcon.elementFactory(1,undefined);
	}
	if (barGraphXAxisIcon[1]) {
		RestStopGameLayout_barGraphXAxisIcon.call(barGraphXAxisIcon[1] as IRestStopGameLayout_barGraphXAxisIcon);
		barGraphXAxisIcon[1].x = 810.5;
		barGraphXAxisIcon[1].y = 494.4;
		barGraphXAxisIcon[1].width = 60.00;
		barGraphXAxisIcon[1].height = 44.00;
		if (barGraphXAxisIcon[1].onLayout) barGraphXAxisIcon[1].onLayout();
	}
	if (!barGraphXAxisIcon[2] && barGraphXAxisIcon.elementFactory) {
		barGraphXAxisIcon[2] = barGraphXAxisIcon.elementFactory(2,undefined);
	}
	if (barGraphXAxisIcon[2]) {
		RestStopGameLayout_barGraphXAxisIcon.call(barGraphXAxisIcon[2] as IRestStopGameLayout_barGraphXAxisIcon);
		barGraphXAxisIcon[2].x = 911;
		barGraphXAxisIcon[2].y = 494.4;
		barGraphXAxisIcon[2].width = 60.00;
		barGraphXAxisIcon[2].height = 44.00;
		if (barGraphXAxisIcon[2].onLayout) barGraphXAxisIcon[2].onLayout();
	}
	const pictoGraphPlusButton = this.pictoGraphPlusButton;
	if (!pictoGraphPlusButton[0] && pictoGraphPlusButton.elementFactory) {
		pictoGraphPlusButton[0] = pictoGraphPlusButton.elementFactory(0,undefined);
	}
	if (pictoGraphPlusButton[0]) {
		RestStopGameLayout_plusButton.call(pictoGraphPlusButton[0] as IRestStopGameLayout_plusButton);
		pictoGraphPlusButton[0].x = 695.8;
		pictoGraphPlusButton[0].y = 553;
		pictoGraphPlusButton[0].width = 62.00;
		pictoGraphPlusButton[0].height = 66.00;
		if (pictoGraphPlusButton[0].onLayout) pictoGraphPlusButton[0].onLayout();
	}
	if (!pictoGraphPlusButton[1] && pictoGraphPlusButton.elementFactory) {
		pictoGraphPlusButton[1] = pictoGraphPlusButton.elementFactory(1,undefined);
	}
	if (pictoGraphPlusButton[1]) {
		RestStopGameLayout_plusButton.call(pictoGraphPlusButton[1] as IRestStopGameLayout_plusButton);
		pictoGraphPlusButton[1].x = 797.8;
		pictoGraphPlusButton[1].y = 553;
		pictoGraphPlusButton[1].width = 62.00;
		pictoGraphPlusButton[1].height = 66.00;
		if (pictoGraphPlusButton[1].onLayout) pictoGraphPlusButton[1].onLayout();
	}
	if (!pictoGraphPlusButton[2] && pictoGraphPlusButton.elementFactory) {
		pictoGraphPlusButton[2] = pictoGraphPlusButton.elementFactory(2,undefined);
	}
	if (pictoGraphPlusButton[2]) {
		RestStopGameLayout_plusButton.call(pictoGraphPlusButton[2] as IRestStopGameLayout_plusButton);
		pictoGraphPlusButton[2].x = 902.8;
		pictoGraphPlusButton[2].y = 553;
		pictoGraphPlusButton[2].width = 62.00;
		pictoGraphPlusButton[2].height = 66.00;
		if (pictoGraphPlusButton[2].onLayout) pictoGraphPlusButton[2].onLayout();
	}
	const pictoGraphColumnOneIconBg = this.pictoGraphColumnOneIconBg;
	if (!pictoGraphColumnOneIconBg[0] && pictoGraphColumnOneIconBg.elementFactory) {
		pictoGraphColumnOneIconBg[0] = pictoGraphColumnOneIconBg.elementFactory(0,undefined);
	}
	if (pictoGraphColumnOneIconBg[0]) {
		RestStopGameLayout_pictoGraphIconBg.call(pictoGraphColumnOneIconBg[0] as IRestStopGameLayout_pictoGraphIconBg);
		pictoGraphColumnOneIconBg[0].x = 696;
		pictoGraphColumnOneIconBg[0].y = 433.5;
		pictoGraphColumnOneIconBg[0].width = 51.00;
		pictoGraphColumnOneIconBg[0].height = 51.00;
		if (pictoGraphColumnOneIconBg[0].onLayout) pictoGraphColumnOneIconBg[0].onLayout();
	}
	if (!pictoGraphColumnOneIconBg[1] && pictoGraphColumnOneIconBg.elementFactory) {
		pictoGraphColumnOneIconBg[1] = pictoGraphColumnOneIconBg.elementFactory(1,undefined);
	}
	if (pictoGraphColumnOneIconBg[1]) {
		RestStopGameLayout_pictoGraphIconBg.call(pictoGraphColumnOneIconBg[1] as IRestStopGameLayout_pictoGraphIconBg);
		pictoGraphColumnOneIconBg[1].x = 696;
		pictoGraphColumnOneIconBg[1].y = 378.25;
		pictoGraphColumnOneIconBg[1].width = 51.00;
		pictoGraphColumnOneIconBg[1].height = 51.00;
		if (pictoGraphColumnOneIconBg[1].onLayout) pictoGraphColumnOneIconBg[1].onLayout();
	}
	if (!pictoGraphColumnOneIconBg[2] && pictoGraphColumnOneIconBg.elementFactory) {
		pictoGraphColumnOneIconBg[2] = pictoGraphColumnOneIconBg.elementFactory(2,undefined);
	}
	if (pictoGraphColumnOneIconBg[2]) {
		RestStopGameLayout_pictoGraphIconBg.call(pictoGraphColumnOneIconBg[2] as IRestStopGameLayout_pictoGraphIconBg);
		pictoGraphColumnOneIconBg[2].x = 696;
		pictoGraphColumnOneIconBg[2].y = 322.25;
		pictoGraphColumnOneIconBg[2].width = 51.00;
		pictoGraphColumnOneIconBg[2].height = 51.00;
		if (pictoGraphColumnOneIconBg[2].onLayout) pictoGraphColumnOneIconBg[2].onLayout();
	}
	if (!pictoGraphColumnOneIconBg[3] && pictoGraphColumnOneIconBg.elementFactory) {
		pictoGraphColumnOneIconBg[3] = pictoGraphColumnOneIconBg.elementFactory(3,undefined);
	}
	if (pictoGraphColumnOneIconBg[3]) {
		RestStopGameLayout_pictoGraphIconBg.call(pictoGraphColumnOneIconBg[3] as IRestStopGameLayout_pictoGraphIconBg);
		pictoGraphColumnOneIconBg[3].x = 696;
		pictoGraphColumnOneIconBg[3].y = 266.35;
		pictoGraphColumnOneIconBg[3].width = 51.00;
		pictoGraphColumnOneIconBg[3].height = 51.00;
		if (pictoGraphColumnOneIconBg[3].onLayout) pictoGraphColumnOneIconBg[3].onLayout();
	}
	const pictoGraphColumnTwoIconBg = this.pictoGraphColumnTwoIconBg;
	if (!pictoGraphColumnTwoIconBg[0] && pictoGraphColumnTwoIconBg.elementFactory) {
		pictoGraphColumnTwoIconBg[0] = pictoGraphColumnTwoIconBg.elementFactory(0,undefined);
	}
	if (pictoGraphColumnTwoIconBg[0]) {
		RestStopGameLayout_pictoGraphIconBg.call(pictoGraphColumnTwoIconBg[0] as IRestStopGameLayout_pictoGraphIconBg);
		pictoGraphColumnTwoIconBg[0].x = 798;
		pictoGraphColumnTwoIconBg[0].y = 433.5;
		pictoGraphColumnTwoIconBg[0].width = 51.00;
		pictoGraphColumnTwoIconBg[0].height = 51.00;
		if (pictoGraphColumnTwoIconBg[0].onLayout) pictoGraphColumnTwoIconBg[0].onLayout();
	}
	if (!pictoGraphColumnTwoIconBg[1] && pictoGraphColumnTwoIconBg.elementFactory) {
		pictoGraphColumnTwoIconBg[1] = pictoGraphColumnTwoIconBg.elementFactory(1,undefined);
	}
	if (pictoGraphColumnTwoIconBg[1]) {
		RestStopGameLayout_pictoGraphIconBg.call(pictoGraphColumnTwoIconBg[1] as IRestStopGameLayout_pictoGraphIconBg);
		pictoGraphColumnTwoIconBg[1].x = 798;
		pictoGraphColumnTwoIconBg[1].y = 378.25;
		pictoGraphColumnTwoIconBg[1].width = 51.00;
		pictoGraphColumnTwoIconBg[1].height = 51.00;
		if (pictoGraphColumnTwoIconBg[1].onLayout) pictoGraphColumnTwoIconBg[1].onLayout();
	}
	if (!pictoGraphColumnTwoIconBg[2] && pictoGraphColumnTwoIconBg.elementFactory) {
		pictoGraphColumnTwoIconBg[2] = pictoGraphColumnTwoIconBg.elementFactory(2,undefined);
	}
	if (pictoGraphColumnTwoIconBg[2]) {
		RestStopGameLayout_pictoGraphIconBg.call(pictoGraphColumnTwoIconBg[2] as IRestStopGameLayout_pictoGraphIconBg);
		pictoGraphColumnTwoIconBg[2].x = 798;
		pictoGraphColumnTwoIconBg[2].y = 322.25;
		pictoGraphColumnTwoIconBg[2].width = 51.00;
		pictoGraphColumnTwoIconBg[2].height = 51.00;
		if (pictoGraphColumnTwoIconBg[2].onLayout) pictoGraphColumnTwoIconBg[2].onLayout();
	}
	if (!pictoGraphColumnTwoIconBg[3] && pictoGraphColumnTwoIconBg.elementFactory) {
		pictoGraphColumnTwoIconBg[3] = pictoGraphColumnTwoIconBg.elementFactory(3,undefined);
	}
	if (pictoGraphColumnTwoIconBg[3]) {
		RestStopGameLayout_pictoGraphIconBg.call(pictoGraphColumnTwoIconBg[3] as IRestStopGameLayout_pictoGraphIconBg);
		pictoGraphColumnTwoIconBg[3].x = 798;
		pictoGraphColumnTwoIconBg[3].y = 266.35;
		pictoGraphColumnTwoIconBg[3].width = 51.00;
		pictoGraphColumnTwoIconBg[3].height = 51.00;
		if (pictoGraphColumnTwoIconBg[3].onLayout) pictoGraphColumnTwoIconBg[3].onLayout();
	}
	const pictoGraphColumnThreeIconBg = this.pictoGraphColumnThreeIconBg;
	if (!pictoGraphColumnThreeIconBg[0] && pictoGraphColumnThreeIconBg.elementFactory) {
		pictoGraphColumnThreeIconBg[0] = pictoGraphColumnThreeIconBg.elementFactory(0,undefined);
	}
	if (pictoGraphColumnThreeIconBg[0]) {
		RestStopGameLayout_pictoGraphIconBg.call(pictoGraphColumnThreeIconBg[0] as IRestStopGameLayout_pictoGraphIconBg);
		pictoGraphColumnThreeIconBg[0].x = 901;
		pictoGraphColumnThreeIconBg[0].y = 433.5;
		pictoGraphColumnThreeIconBg[0].width = 51.00;
		pictoGraphColumnThreeIconBg[0].height = 51.00;
		if (pictoGraphColumnThreeIconBg[0].onLayout) pictoGraphColumnThreeIconBg[0].onLayout();
	}
	if (!pictoGraphColumnThreeIconBg[1] && pictoGraphColumnThreeIconBg.elementFactory) {
		pictoGraphColumnThreeIconBg[1] = pictoGraphColumnThreeIconBg.elementFactory(1,undefined);
	}
	if (pictoGraphColumnThreeIconBg[1]) {
		RestStopGameLayout_pictoGraphIconBg.call(pictoGraphColumnThreeIconBg[1] as IRestStopGameLayout_pictoGraphIconBg);
		pictoGraphColumnThreeIconBg[1].x = 901;
		pictoGraphColumnThreeIconBg[1].y = 378.25;
		pictoGraphColumnThreeIconBg[1].width = 51.00;
		pictoGraphColumnThreeIconBg[1].height = 51.00;
		if (pictoGraphColumnThreeIconBg[1].onLayout) pictoGraphColumnThreeIconBg[1].onLayout();
	}
	if (!pictoGraphColumnThreeIconBg[2] && pictoGraphColumnThreeIconBg.elementFactory) {
		pictoGraphColumnThreeIconBg[2] = pictoGraphColumnThreeIconBg.elementFactory(2,undefined);
	}
	if (pictoGraphColumnThreeIconBg[2]) {
		RestStopGameLayout_pictoGraphIconBg.call(pictoGraphColumnThreeIconBg[2] as IRestStopGameLayout_pictoGraphIconBg);
		pictoGraphColumnThreeIconBg[2].x = 901;
		pictoGraphColumnThreeIconBg[2].y = 322.25;
		pictoGraphColumnThreeIconBg[2].width = 51.00;
		pictoGraphColumnThreeIconBg[2].height = 51.00;
		if (pictoGraphColumnThreeIconBg[2].onLayout) pictoGraphColumnThreeIconBg[2].onLayout();
	}
	if (!pictoGraphColumnThreeIconBg[3] && pictoGraphColumnThreeIconBg.elementFactory) {
		pictoGraphColumnThreeIconBg[3] = pictoGraphColumnThreeIconBg.elementFactory(3,undefined);
	}
	if (pictoGraphColumnThreeIconBg[3]) {
		RestStopGameLayout_pictoGraphIconBg.call(pictoGraphColumnThreeIconBg[3] as IRestStopGameLayout_pictoGraphIconBg);
		pictoGraphColumnThreeIconBg[3].x = 901;
		pictoGraphColumnThreeIconBg[3].y = 266.35;
		pictoGraphColumnThreeIconBg[3].width = 51.00;
		pictoGraphColumnThreeIconBg[3].height = 51.00;
		if (pictoGraphColumnThreeIconBg[3].onLayout) pictoGraphColumnThreeIconBg[3].onLayout();
	}
	const pictoGraphXAxisIcon = this.pictoGraphXAxisIcon;
	if (!pictoGraphXAxisIcon[0] && pictoGraphXAxisIcon.elementFactory) {
		pictoGraphXAxisIcon[0] = pictoGraphXAxisIcon.elementFactory(0,undefined);
	}
	if (pictoGraphXAxisIcon[0]) {
		RestStopGameLayout_pictoGraphXAxisIcon.call(pictoGraphXAxisIcon[0] as IRestStopGameLayout_pictoGraphXAxisIcon);
		pictoGraphXAxisIcon[0].x = 695.8;
		pictoGraphXAxisIcon[0].y = 493.5;
		pictoGraphXAxisIcon[0].width = 60.00;
		pictoGraphXAxisIcon[0].height = 44.00;
		if (pictoGraphXAxisIcon[0].onLayout) pictoGraphXAxisIcon[0].onLayout();
	}
	if (!pictoGraphXAxisIcon[1] && pictoGraphXAxisIcon.elementFactory) {
		pictoGraphXAxisIcon[1] = pictoGraphXAxisIcon.elementFactory(1,undefined);
	}
	if (pictoGraphXAxisIcon[1]) {
		RestStopGameLayout_pictoGraphXAxisIcon.call(pictoGraphXAxisIcon[1] as IRestStopGameLayout_pictoGraphXAxisIcon);
		pictoGraphXAxisIcon[1].x = 797.8;
		pictoGraphXAxisIcon[1].y = 493.5;
		pictoGraphXAxisIcon[1].width = 60.00;
		pictoGraphXAxisIcon[1].height = 44.00;
		if (pictoGraphXAxisIcon[1].onLayout) pictoGraphXAxisIcon[1].onLayout();
	}
	if (!pictoGraphXAxisIcon[2] && pictoGraphXAxisIcon.elementFactory) {
		pictoGraphXAxisIcon[2] = pictoGraphXAxisIcon.elementFactory(2,undefined);
	}
	if (pictoGraphXAxisIcon[2]) {
		RestStopGameLayout_pictoGraphXAxisIcon.call(pictoGraphXAxisIcon[2] as IRestStopGameLayout_pictoGraphXAxisIcon);
		pictoGraphXAxisIcon[2].x = 901.8;
		pictoGraphXAxisIcon[2].y = 493.5;
		pictoGraphXAxisIcon[2].width = 60.00;
		pictoGraphXAxisIcon[2].height = 44.00;
		if (pictoGraphXAxisIcon[2].onLayout) pictoGraphXAxisIcon[2].onLayout();
	}
	const compareGraphStressorsTitleBg = this.compareGraphStressorsTitleBg;
	if (!compareGraphStressorsTitleBg[0] && compareGraphStressorsTitleBg.elementFactory) {
		compareGraphStressorsTitleBg[0] = compareGraphStressorsTitleBg.elementFactory(0,undefined);
	}
	if (compareGraphStressorsTitleBg[0]) {
		RestStopGameLayout_compareGraphTitleBg.call(compareGraphStressorsTitleBg[0] as IRestStopGameLayout_compareGraphTitleBg);
		compareGraphStressorsTitleBg[0].x = 183.4;
		compareGraphStressorsTitleBg[0].y = 356.5;
		compareGraphStressorsTitleBg[0].width = 162.00;
		compareGraphStressorsTitleBg[0].height = 45.00;
		if (compareGraphStressorsTitleBg[0].onLayout) compareGraphStressorsTitleBg[0].onLayout();
	}
	if (!compareGraphStressorsTitleBg[1] && compareGraphStressorsTitleBg.elementFactory) {
		compareGraphStressorsTitleBg[1] = compareGraphStressorsTitleBg.elementFactory(1,undefined);
	}
	if (compareGraphStressorsTitleBg[1]) {
		RestStopGameLayout_compareGraphTitleBg.call(compareGraphStressorsTitleBg[1] as IRestStopGameLayout_compareGraphTitleBg);
		compareGraphStressorsTitleBg[1].x = 650.9;
		compareGraphStressorsTitleBg[1].y = 356.5;
		compareGraphStressorsTitleBg[1].width = 162.00;
		compareGraphStressorsTitleBg[1].height = 45.00;
		if (compareGraphStressorsTitleBg[1].onLayout) compareGraphStressorsTitleBg[1].onLayout();
	}
	const compareGraphResourcesTitleBg = this.compareGraphResourcesTitleBg;
	if (!compareGraphResourcesTitleBg[0] && compareGraphResourcesTitleBg.elementFactory) {
		compareGraphResourcesTitleBg[0] = compareGraphResourcesTitleBg.elementFactory(0,undefined);
	}
	if (compareGraphResourcesTitleBg[0]) {
		RestStopGameLayout_compareGraphTitleBg.call(compareGraphResourcesTitleBg[0] as IRestStopGameLayout_compareGraphTitleBg);
		compareGraphResourcesTitleBg[0].x = 378.4;
		compareGraphResourcesTitleBg[0].y = 356.5;
		compareGraphResourcesTitleBg[0].width = 162.00;
		compareGraphResourcesTitleBg[0].height = 45.00;
		if (compareGraphResourcesTitleBg[0].onLayout) compareGraphResourcesTitleBg[0].onLayout();
	}
	if (!compareGraphResourcesTitleBg[1] && compareGraphResourcesTitleBg.elementFactory) {
		compareGraphResourcesTitleBg[1] = compareGraphResourcesTitleBg.elementFactory(1,undefined);
	}
	if (compareGraphResourcesTitleBg[1]) {
		RestStopGameLayout_compareGraphTitleBg.call(compareGraphResourcesTitleBg[1] as IRestStopGameLayout_compareGraphTitleBg);
		compareGraphResourcesTitleBg[1].x = 845.65;
		compareGraphResourcesTitleBg[1].y = 356.5;
		compareGraphResourcesTitleBg[1].width = 162.00;
		compareGraphResourcesTitleBg[1].height = 45.00;
		if (compareGraphResourcesTitleBg[1].onLayout) compareGraphResourcesTitleBg[1].onLayout();
	}
	const sadFace = this.sadFace;
	if (!sadFace[0] && sadFace.elementFactory) {
		sadFace[0] = sadFace.elementFactory(0,undefined);
	}
	if (sadFace[0]) {
		RestStopGameLayout_sadFace0.call(sadFace[0] as IRestStopGameLayout_sadFace0);
		sadFace[0].x = 242.8;
		sadFace[0].y = 357.1;
		sadFace[0].width = 28.00;
		sadFace[0].height = 28.00;
		if (sadFace[0].onLayout) sadFace[0].onLayout();
	}
	if (!sadFace[1] && sadFace.elementFactory) {
		sadFace[1] = sadFace.elementFactory(1,undefined);
	}
	if (sadFace[1]) {
		RestStopGameLayout_sadFace0.call(sadFace[1] as IRestStopGameLayout_sadFace0);
		sadFace[1].x = 710;
		sadFace[1].y = 357.1;
		sadFace[1].width = 28.00;
		sadFace[1].height = 28.00;
		if (sadFace[1].onLayout) sadFace[1].onLayout();
	}
	const happyFace = this.happyFace;
	if (!happyFace[0] && happyFace.elementFactory) {
		happyFace[0] = happyFace.elementFactory(0,undefined);
	}
	if (happyFace[0]) {
		RestStopGameLayout_happyFace0.call(happyFace[0] as IRestStopGameLayout_happyFace0);
		happyFace[0].x = 438;
		happyFace[0].y = 357.1;
		happyFace[0].width = 28.00;
		happyFace[0].height = 28.00;
		if (happyFace[0].onLayout) happyFace[0].onLayout();
	}
	if (!happyFace[1] && happyFace.elementFactory) {
		happyFace[1] = happyFace.elementFactory(1,undefined);
	}
	if (happyFace[1]) {
		RestStopGameLayout_happyFace0.call(happyFace[1] as IRestStopGameLayout_happyFace0);
		happyFace[1].x = 905.7;
		happyFace[1].y = 357.1;
		happyFace[1].width = 28.00;
		happyFace[1].height = 28.00;
		if (happyFace[1].onLayout) happyFace[1].onLayout();
	}
	const comparePondTitleBg = this.comparePondTitleBg;
	if (!comparePondTitleBg[0] && comparePondTitleBg.elementFactory) {
		comparePondTitleBg[0] = comparePondTitleBg.elementFactory(0,undefined);
	}
	if (comparePondTitleBg[0]) {
		RestStopGameLayout_comparePondTitleBg.call(comparePondTitleBg[0] as IRestStopGameLayout_comparePondTitleBg);
		comparePondTitleBg[0].x = 281.6;
		comparePondTitleBg[0].y = 300.05;
		comparePondTitleBg[0].width = 137.00;
		comparePondTitleBg[0].height = 45.00;
		if (comparePondTitleBg[0].onLayout) comparePondTitleBg[0].onLayout();
	}
	if (!comparePondTitleBg[1] && comparePondTitleBg.elementFactory) {
		comparePondTitleBg[1] = comparePondTitleBg.elementFactory(1,undefined);
	}
	if (comparePondTitleBg[1]) {
		RestStopGameLayout_comparePondTitleBg.call(comparePondTitleBg[1] as IRestStopGameLayout_comparePondTitleBg);
		comparePondTitleBg[1].x = 748.55;
		comparePondTitleBg[1].y = 300.05;
		comparePondTitleBg[1].width = 137.00;
		comparePondTitleBg[1].height = 45.00;
		if (comparePondTitleBg[1].onLayout) comparePondTitleBg[1].onLayout();
	}
	const compareGraphPictoGraphPondOneStressorsBarOneIconBg = this.compareGraphPictoGraphPondOneStressorsBarOneIconBg;
	if (!compareGraphPictoGraphPondOneStressorsBarOneIconBg[0] && compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[0] = compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory(0,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[0]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarOneIconBg[0] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[0].x = 110.6;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[0].y = 569.1;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[0].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[0].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[0].onLayout) compareGraphPictoGraphPondOneStressorsBarOneIconBg[0].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarOneIconBg[1] && compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[1] = compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory(1,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[1]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarOneIconBg[1] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[1].x = 110.6;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[1].y = 519.2;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[1].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[1].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[1].onLayout) compareGraphPictoGraphPondOneStressorsBarOneIconBg[1].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarOneIconBg[2] && compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[2] = compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory(2,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[2]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarOneIconBg[2] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[2].x = 110.6;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[2].y = 468.65;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[2].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[2].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[2].onLayout) compareGraphPictoGraphPondOneStressorsBarOneIconBg[2].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarOneIconBg[3] && compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[3] = compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory(3,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[3]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarOneIconBg[3] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[3].x = 110.6;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[3].y = 418.6;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[3].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[3].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[3].onLayout) compareGraphPictoGraphPondOneStressorsBarOneIconBg[3].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarOneIconBg[4] && compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[4] = compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory(4,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[4]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarOneIconBg[4] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[4].x = 110.6;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[4].y = 569.1;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[4].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[4].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[4].onLayout) compareGraphPictoGraphPondOneStressorsBarOneIconBg[4].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarOneIconBg[5] && compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[5] = compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory(5,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[5]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarOneIconBg[5] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[5].x = 110.6;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[5].y = 519.2;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[5].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[5].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[5].onLayout) compareGraphPictoGraphPondOneStressorsBarOneIconBg[5].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarOneIconBg[6] && compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[6] = compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory(6,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[6]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarOneIconBg[6] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[6].x = 110.6;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[6].y = 468.65;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[6].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[6].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[6].onLayout) compareGraphPictoGraphPondOneStressorsBarOneIconBg[6].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarOneIconBg[7] && compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[7] = compareGraphPictoGraphPondOneStressorsBarOneIconBg.elementFactory(7,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[7]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarOneIconBg[7] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[7].x = 110.6;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[7].y = 418.6;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[7].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarOneIconBg[7].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarOneIconBg[7].onLayout) compareGraphPictoGraphPondOneStressorsBarOneIconBg[7].onLayout();
	}
	const compareGraphPictoGraphPondOneStressorsBarTwoIconBg = this.compareGraphPictoGraphPondOneStressorsBarTwoIconBg;
	if (!compareGraphPictoGraphPondOneStressorsBarTwoIconBg[0] && compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[0] = compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory(0,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[0]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarTwoIconBg[0] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[0].x = 173.85;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[0].y = 569.1;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[0].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[0].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[0].onLayout) compareGraphPictoGraphPondOneStressorsBarTwoIconBg[0].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarTwoIconBg[1] && compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[1] = compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory(1,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[1]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarTwoIconBg[1] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[1].x = 173.85;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[1].y = 519.2;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[1].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[1].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[1].onLayout) compareGraphPictoGraphPondOneStressorsBarTwoIconBg[1].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarTwoIconBg[2] && compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[2] = compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory(2,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[2]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarTwoIconBg[2] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[2].x = 173.85;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[2].y = 468.65;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[2].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[2].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[2].onLayout) compareGraphPictoGraphPondOneStressorsBarTwoIconBg[2].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarTwoIconBg[3] && compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[3] = compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory(3,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[3]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarTwoIconBg[3] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[3].x = 173.85;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[3].y = 418.6;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[3].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[3].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[3].onLayout) compareGraphPictoGraphPondOneStressorsBarTwoIconBg[3].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarTwoIconBg[4] && compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[4] = compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory(4,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[4]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarTwoIconBg[4] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[4].x = 173.85;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[4].y = 569.1;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[4].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[4].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[4].onLayout) compareGraphPictoGraphPondOneStressorsBarTwoIconBg[4].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarTwoIconBg[5] && compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[5] = compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory(5,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[5]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarTwoIconBg[5] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[5].x = 173.85;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[5].y = 519.2;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[5].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[5].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[5].onLayout) compareGraphPictoGraphPondOneStressorsBarTwoIconBg[5].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarTwoIconBg[6] && compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[6] = compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory(6,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[6]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarTwoIconBg[6] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[6].x = 173.85;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[6].y = 468.65;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[6].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[6].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[6].onLayout) compareGraphPictoGraphPondOneStressorsBarTwoIconBg[6].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarTwoIconBg[7] && compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[7] = compareGraphPictoGraphPondOneStressorsBarTwoIconBg.elementFactory(7,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[7]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarTwoIconBg[7] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[7].x = 173.85;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[7].y = 418.6;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[7].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarTwoIconBg[7].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarTwoIconBg[7].onLayout) compareGraphPictoGraphPondOneStressorsBarTwoIconBg[7].onLayout();
	}
	const compareGraphPictoGraphPondOneStressorsBarThreeIconBg = this.compareGraphPictoGraphPondOneStressorsBarThreeIconBg;
	if (!compareGraphPictoGraphPondOneStressorsBarThreeIconBg[0] && compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[0] = compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory(0,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[0]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarThreeIconBg[0] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[0].x = 236.8;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[0].y = 569.1;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[0].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[0].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[0].onLayout) compareGraphPictoGraphPondOneStressorsBarThreeIconBg[0].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarThreeIconBg[1] && compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[1] = compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory(1,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[1]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarThreeIconBg[1] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[1].x = 236.8;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[1].y = 519.2;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[1].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[1].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[1].onLayout) compareGraphPictoGraphPondOneStressorsBarThreeIconBg[1].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarThreeIconBg[2] && compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[2] = compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory(2,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[2]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarThreeIconBg[2] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[2].x = 236.8;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[2].y = 468.65;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[2].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[2].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[2].onLayout) compareGraphPictoGraphPondOneStressorsBarThreeIconBg[2].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarThreeIconBg[3] && compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[3] = compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory(3,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[3]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarThreeIconBg[3] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[3].x = 236.8;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[3].y = 418.6;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[3].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[3].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[3].onLayout) compareGraphPictoGraphPondOneStressorsBarThreeIconBg[3].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarThreeIconBg[4] && compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[4] = compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory(4,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[4]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarThreeIconBg[4] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[4].x = 236.8;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[4].y = 569.1;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[4].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[4].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[4].onLayout) compareGraphPictoGraphPondOneStressorsBarThreeIconBg[4].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarThreeIconBg[5] && compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[5] = compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory(5,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[5]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarThreeIconBg[5] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[5].x = 236.8;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[5].y = 519.2;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[5].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[5].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[5].onLayout) compareGraphPictoGraphPondOneStressorsBarThreeIconBg[5].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarThreeIconBg[6] && compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[6] = compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory(6,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[6]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarThreeIconBg[6] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[6].x = 236.8;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[6].y = 468.65;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[6].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[6].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[6].onLayout) compareGraphPictoGraphPondOneStressorsBarThreeIconBg[6].onLayout();
	}
	if (!compareGraphPictoGraphPondOneStressorsBarThreeIconBg[7] && compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[7] = compareGraphPictoGraphPondOneStressorsBarThreeIconBg.elementFactory(7,undefined);
	}
	if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[7]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneStressorsBarThreeIconBg[7] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[7].x = 236.8;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[7].y = 418.6;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[7].width = 46.50;
		compareGraphPictoGraphPondOneStressorsBarThreeIconBg[7].height = 49.00;
		if (compareGraphPictoGraphPondOneStressorsBarThreeIconBg[7].onLayout) compareGraphPictoGraphPondOneStressorsBarThreeIconBg[7].onLayout();
	}
	const compareGraphPictoGraphPondOneResourcesBarOneIconBg = this.compareGraphPictoGraphPondOneResourcesBarOneIconBg;
	if (!compareGraphPictoGraphPondOneResourcesBarOneIconBg[0] && compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[0] = compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory(0,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[0]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarOneIconBg[0] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[0].x = 329.6;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[0].y = 569.1;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[0].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[0].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[0].onLayout) compareGraphPictoGraphPondOneResourcesBarOneIconBg[0].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarOneIconBg[1] && compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[1] = compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory(1,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[1]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarOneIconBg[1] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[1].x = 329.6;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[1].y = 519.2;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[1].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[1].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[1].onLayout) compareGraphPictoGraphPondOneResourcesBarOneIconBg[1].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarOneIconBg[2] && compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[2] = compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory(2,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[2]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarOneIconBg[2] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[2].x = 329.6;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[2].y = 468.65;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[2].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[2].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[2].onLayout) compareGraphPictoGraphPondOneResourcesBarOneIconBg[2].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarOneIconBg[3] && compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[3] = compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory(3,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[3]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarOneIconBg[3] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[3].x = 329.6;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[3].y = 418.6;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[3].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[3].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[3].onLayout) compareGraphPictoGraphPondOneResourcesBarOneIconBg[3].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarOneIconBg[4] && compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[4] = compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory(4,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[4]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarOneIconBg[4] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[4].x = 329.6;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[4].y = 569.1;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[4].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[4].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[4].onLayout) compareGraphPictoGraphPondOneResourcesBarOneIconBg[4].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarOneIconBg[5] && compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[5] = compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory(5,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[5]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarOneIconBg[5] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[5].x = 329.6;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[5].y = 519.2;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[5].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[5].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[5].onLayout) compareGraphPictoGraphPondOneResourcesBarOneIconBg[5].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarOneIconBg[6] && compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[6] = compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory(6,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[6]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarOneIconBg[6] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[6].x = 329.6;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[6].y = 468.65;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[6].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[6].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[6].onLayout) compareGraphPictoGraphPondOneResourcesBarOneIconBg[6].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarOneIconBg[7] && compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[7] = compareGraphPictoGraphPondOneResourcesBarOneIconBg.elementFactory(7,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[7]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarOneIconBg[7] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[7].x = 329.6;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[7].y = 418.6;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[7].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarOneIconBg[7].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarOneIconBg[7].onLayout) compareGraphPictoGraphPondOneResourcesBarOneIconBg[7].onLayout();
	}
	const compareGraphPictoGraphPondOneResourcesBarTwoIconBg = this.compareGraphPictoGraphPondOneResourcesBarTwoIconBg;
	if (!compareGraphPictoGraphPondOneResourcesBarTwoIconBg[0] && compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[0] = compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory(0,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[0]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarTwoIconBg[0] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[0].x = 392.85;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[0].y = 569.1;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[0].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[0].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[0].onLayout) compareGraphPictoGraphPondOneResourcesBarTwoIconBg[0].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarTwoIconBg[1] && compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[1] = compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory(1,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[1]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarTwoIconBg[1] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[1].x = 392.85;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[1].y = 519.2;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[1].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[1].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[1].onLayout) compareGraphPictoGraphPondOneResourcesBarTwoIconBg[1].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarTwoIconBg[2] && compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[2] = compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory(2,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[2]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarTwoIconBg[2] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[2].x = 392.85;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[2].y = 468.65;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[2].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[2].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[2].onLayout) compareGraphPictoGraphPondOneResourcesBarTwoIconBg[2].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarTwoIconBg[3] && compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[3] = compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory(3,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[3]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarTwoIconBg[3] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[3].x = 392.85;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[3].y = 418.6;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[3].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[3].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[3].onLayout) compareGraphPictoGraphPondOneResourcesBarTwoIconBg[3].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarTwoIconBg[4] && compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[4] = compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory(4,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[4]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarTwoIconBg[4] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[4].x = 392.85;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[4].y = 569.1;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[4].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[4].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[4].onLayout) compareGraphPictoGraphPondOneResourcesBarTwoIconBg[4].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarTwoIconBg[5] && compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[5] = compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory(5,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[5]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarTwoIconBg[5] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[5].x = 392.85;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[5].y = 519.2;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[5].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[5].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[5].onLayout) compareGraphPictoGraphPondOneResourcesBarTwoIconBg[5].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarTwoIconBg[6] && compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[6] = compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory(6,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[6]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarTwoIconBg[6] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[6].x = 392.85;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[6].y = 468.65;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[6].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[6].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[6].onLayout) compareGraphPictoGraphPondOneResourcesBarTwoIconBg[6].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarTwoIconBg[7] && compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[7] = compareGraphPictoGraphPondOneResourcesBarTwoIconBg.elementFactory(7,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[7]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarTwoIconBg[7] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[7].x = 392.85;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[7].y = 418.6;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[7].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarTwoIconBg[7].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarTwoIconBg[7].onLayout) compareGraphPictoGraphPondOneResourcesBarTwoIconBg[7].onLayout();
	}
	const compareGraphPictoGraphPondOneResourcesBarThreeIconBg = this.compareGraphPictoGraphPondOneResourcesBarThreeIconBg;
	if (!compareGraphPictoGraphPondOneResourcesBarThreeIconBg[0] && compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[0] = compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory(0,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[0]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarThreeIconBg[0] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[0].x = 455.8;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[0].y = 569.1;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[0].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[0].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[0].onLayout) compareGraphPictoGraphPondOneResourcesBarThreeIconBg[0].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarThreeIconBg[1] && compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[1] = compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory(1,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[1]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarThreeIconBg[1] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[1].x = 455.8;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[1].y = 519.2;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[1].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[1].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[1].onLayout) compareGraphPictoGraphPondOneResourcesBarThreeIconBg[1].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarThreeIconBg[2] && compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[2] = compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory(2,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[2]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarThreeIconBg[2] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[2].x = 455.8;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[2].y = 468.65;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[2].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[2].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[2].onLayout) compareGraphPictoGraphPondOneResourcesBarThreeIconBg[2].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarThreeIconBg[3] && compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[3] = compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory(3,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[3]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarThreeIconBg[3] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[3].x = 455.8;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[3].y = 418.6;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[3].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[3].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[3].onLayout) compareGraphPictoGraphPondOneResourcesBarThreeIconBg[3].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarThreeIconBg[4] && compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[4] = compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory(4,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[4]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarThreeIconBg[4] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[4].x = 455.8;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[4].y = 569.1;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[4].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[4].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[4].onLayout) compareGraphPictoGraphPondOneResourcesBarThreeIconBg[4].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarThreeIconBg[5] && compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[5] = compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory(5,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[5]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarThreeIconBg[5] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[5].x = 455.8;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[5].y = 519.2;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[5].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[5].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[5].onLayout) compareGraphPictoGraphPondOneResourcesBarThreeIconBg[5].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarThreeIconBg[6] && compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[6] = compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory(6,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[6]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarThreeIconBg[6] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[6].x = 455.8;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[6].y = 468.65;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[6].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[6].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[6].onLayout) compareGraphPictoGraphPondOneResourcesBarThreeIconBg[6].onLayout();
	}
	if (!compareGraphPictoGraphPondOneResourcesBarThreeIconBg[7] && compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[7] = compareGraphPictoGraphPondOneResourcesBarThreeIconBg.elementFactory(7,undefined);
	}
	if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[7]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondOneResourcesBarThreeIconBg[7] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[7].x = 455.8;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[7].y = 418.6;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[7].width = 46.50;
		compareGraphPictoGraphPondOneResourcesBarThreeIconBg[7].height = 49.00;
		if (compareGraphPictoGraphPondOneResourcesBarThreeIconBg[7].onLayout) compareGraphPictoGraphPondOneResourcesBarThreeIconBg[7].onLayout();
	}
	const compareGraphPictoGraphPondTwoResourcesBarOneIconBg = this.compareGraphPictoGraphPondTwoResourcesBarOneIconBg;
	if (!compareGraphPictoGraphPondTwoResourcesBarOneIconBg[0] && compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[0] = compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory(0,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[0]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarOneIconBg[0] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[0].x = 797.1;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[0].y = 569.1;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[0].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[0].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[0].onLayout) compareGraphPictoGraphPondTwoResourcesBarOneIconBg[0].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarOneIconBg[1] && compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[1] = compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory(1,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[1]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarOneIconBg[1] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[1].x = 797.1;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[1].y = 519.2;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[1].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[1].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[1].onLayout) compareGraphPictoGraphPondTwoResourcesBarOneIconBg[1].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarOneIconBg[2] && compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[2] = compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory(2,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[2]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarOneIconBg[2] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[2].x = 797.1;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[2].y = 468.65;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[2].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[2].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[2].onLayout) compareGraphPictoGraphPondTwoResourcesBarOneIconBg[2].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarOneIconBg[3] && compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[3] = compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory(3,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[3]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarOneIconBg[3] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[3].x = 797.1;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[3].y = 418.6;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[3].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[3].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[3].onLayout) compareGraphPictoGraphPondTwoResourcesBarOneIconBg[3].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarOneIconBg[4] && compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[4] = compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory(4,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[4]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarOneIconBg[4] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[4].x = 797.1;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[4].y = 569.1;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[4].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[4].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[4].onLayout) compareGraphPictoGraphPondTwoResourcesBarOneIconBg[4].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarOneIconBg[5] && compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[5] = compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory(5,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[5]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarOneIconBg[5] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[5].x = 797.1;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[5].y = 519.2;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[5].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[5].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[5].onLayout) compareGraphPictoGraphPondTwoResourcesBarOneIconBg[5].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarOneIconBg[6] && compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[6] = compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory(6,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[6]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarOneIconBg[6] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[6].x = 797.1;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[6].y = 468.65;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[6].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[6].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[6].onLayout) compareGraphPictoGraphPondTwoResourcesBarOneIconBg[6].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarOneIconBg[7] && compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[7] = compareGraphPictoGraphPondTwoResourcesBarOneIconBg.elementFactory(7,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[7]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarOneIconBg[7] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[7].x = 797.1;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[7].y = 418.6;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[7].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarOneIconBg[7].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarOneIconBg[7].onLayout) compareGraphPictoGraphPondTwoResourcesBarOneIconBg[7].onLayout();
	}
	const compareGraphPictoGraphPondTwoResourcesBarTwoIconBg = this.compareGraphPictoGraphPondTwoResourcesBarTwoIconBg;
	if (!compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[0] && compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[0] = compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory(0,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[0]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[0] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[0].x = 860.35;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[0].y = 569.1;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[0].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[0].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[0].onLayout) compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[0].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[1] && compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[1] = compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory(1,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[1]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[1] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[1].x = 860.35;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[1].y = 519.2;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[1].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[1].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[1].onLayout) compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[1].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[2] && compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[2] = compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory(2,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[2]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[2] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[2].x = 860.35;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[2].y = 468.65;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[2].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[2].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[2].onLayout) compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[2].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[3] && compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[3] = compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory(3,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[3]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[3] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[3].x = 860.35;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[3].y = 418.6;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[3].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[3].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[3].onLayout) compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[3].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[4] && compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[4] = compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory(4,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[4]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[4] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[4].x = 860.35;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[4].y = 569.1;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[4].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[4].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[4].onLayout) compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[4].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[5] && compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[5] = compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory(5,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[5]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[5] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[5].x = 860.35;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[5].y = 519.2;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[5].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[5].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[5].onLayout) compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[5].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[6] && compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[6] = compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory(6,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[6]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[6] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[6].x = 860.35;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[6].y = 468.65;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[6].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[6].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[6].onLayout) compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[6].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[7] && compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[7] = compareGraphPictoGraphPondTwoResourcesBarTwoIconBg.elementFactory(7,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[7]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[7] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[7].x = 860.35;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[7].y = 418.6;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[7].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[7].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[7].onLayout) compareGraphPictoGraphPondTwoResourcesBarTwoIconBg[7].onLayout();
	}
	const compareGraphPictoGraphPondTwoResourcesBarThreeIconBg = this.compareGraphPictoGraphPondTwoResourcesBarThreeIconBg;
	if (!compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[0] && compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[0] = compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory(0,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[0]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[0] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[0].x = 923.3;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[0].y = 569.1;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[0].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[0].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[0].onLayout) compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[0].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[1] && compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[1] = compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory(1,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[1]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[1] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[1].x = 923.3;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[1].y = 519.2;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[1].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[1].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[1].onLayout) compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[1].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[2] && compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[2] = compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory(2,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[2]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[2] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[2].x = 923.3;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[2].y = 468.65;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[2].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[2].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[2].onLayout) compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[2].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[3] && compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[3] = compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory(3,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[3]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[3] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[3].x = 923.3;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[3].y = 418.6;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[3].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[3].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[3].onLayout) compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[3].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[4] && compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[4] = compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory(4,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[4]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[4] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[4].x = 923.3;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[4].y = 569.1;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[4].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[4].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[4].onLayout) compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[4].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[5] && compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[5] = compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory(5,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[5]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[5] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[5].x = 923.3;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[5].y = 519.2;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[5].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[5].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[5].onLayout) compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[5].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[6] && compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[6] = compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory(6,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[6]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[6] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[6].x = 923.3;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[6].y = 468.65;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[6].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[6].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[6].onLayout) compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[6].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[7] && compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[7] = compareGraphPictoGraphPondTwoResourcesBarThreeIconBg.elementFactory(7,undefined);
	}
	if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[7]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[7] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[7].x = 923.3;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[7].y = 418.6;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[7].width = 46.50;
		compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[7].height = 49.00;
		if (compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[7].onLayout) compareGraphPictoGraphPondTwoResourcesBarThreeIconBg[7].onLayout();
	}
	const compareGraphPictoGraphPondTwoStressorsBarOneIconBg = this.compareGraphPictoGraphPondTwoStressorsBarOneIconBg;
	if (!compareGraphPictoGraphPondTwoStressorsBarOneIconBg[0] && compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[0] = compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory(0,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[0]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarOneIconBg[0] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[0].x = 577.6;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[0].y = 569.1;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[0].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[0].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[0].onLayout) compareGraphPictoGraphPondTwoStressorsBarOneIconBg[0].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarOneIconBg[1] && compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[1] = compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory(1,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[1]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarOneIconBg[1] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[1].x = 577.6;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[1].y = 519.2;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[1].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[1].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[1].onLayout) compareGraphPictoGraphPondTwoStressorsBarOneIconBg[1].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarOneIconBg[2] && compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[2] = compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory(2,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[2]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarOneIconBg[2] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[2].x = 577.6;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[2].y = 468.65;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[2].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[2].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[2].onLayout) compareGraphPictoGraphPondTwoStressorsBarOneIconBg[2].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarOneIconBg[3] && compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[3] = compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory(3,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[3]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarOneIconBg[3] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[3].x = 577.6;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[3].y = 418.6;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[3].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[3].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[3].onLayout) compareGraphPictoGraphPondTwoStressorsBarOneIconBg[3].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarOneIconBg[4] && compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[4] = compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory(4,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[4]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarOneIconBg[4] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[4].x = 577.6;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[4].y = 569.1;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[4].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[4].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[4].onLayout) compareGraphPictoGraphPondTwoStressorsBarOneIconBg[4].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarOneIconBg[5] && compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[5] = compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory(5,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[5]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarOneIconBg[5] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[5].x = 577.6;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[5].y = 519.2;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[5].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[5].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[5].onLayout) compareGraphPictoGraphPondTwoStressorsBarOneIconBg[5].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarOneIconBg[6] && compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[6] = compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory(6,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[6]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarOneIconBg[6] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[6].x = 577.6;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[6].y = 468.65;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[6].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[6].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[6].onLayout) compareGraphPictoGraphPondTwoStressorsBarOneIconBg[6].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarOneIconBg[7] && compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[7] = compareGraphPictoGraphPondTwoStressorsBarOneIconBg.elementFactory(7,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[7]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarOneIconBg[7] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[7].x = 577.6;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[7].y = 418.6;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[7].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarOneIconBg[7].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarOneIconBg[7].onLayout) compareGraphPictoGraphPondTwoStressorsBarOneIconBg[7].onLayout();
	}
	const compareGraphPictoGraphPondTwoStressorsBarTwoIconBg = this.compareGraphPictoGraphPondTwoStressorsBarTwoIconBg;
	if (!compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[0] && compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[0] = compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory(0,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[0]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[0] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[0].x = 640.85;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[0].y = 569.1;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[0].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[0].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[0].onLayout) compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[0].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[1] && compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[1] = compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory(1,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[1]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[1] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[1].x = 640.85;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[1].y = 519.2;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[1].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[1].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[1].onLayout) compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[1].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[2] && compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[2] = compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory(2,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[2]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[2] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[2].x = 640.85;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[2].y = 468.65;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[2].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[2].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[2].onLayout) compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[2].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[3] && compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[3] = compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory(3,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[3]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[3] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[3].x = 640.85;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[3].y = 418.6;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[3].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[3].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[3].onLayout) compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[3].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[4] && compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[4] = compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory(4,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[4]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[4] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[4].x = 640.85;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[4].y = 569.1;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[4].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[4].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[4].onLayout) compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[4].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[5] && compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[5] = compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory(5,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[5]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[5] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[5].x = 640.85;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[5].y = 519.2;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[5].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[5].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[5].onLayout) compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[5].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[6] && compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[6] = compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory(6,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[6]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[6] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[6].x = 640.85;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[6].y = 468.65;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[6].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[6].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[6].onLayout) compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[6].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[7] && compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[7] = compareGraphPictoGraphPondTwoStressorsBarTwoIconBg.elementFactory(7,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[7]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[7] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[7].x = 640.85;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[7].y = 418.6;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[7].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[7].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[7].onLayout) compareGraphPictoGraphPondTwoStressorsBarTwoIconBg[7].onLayout();
	}
	const compareGraphPictoGraphPondTwoStressorsBarThreeIconBg = this.compareGraphPictoGraphPondTwoStressorsBarThreeIconBg;
	if (!compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[0] && compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[0] = compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory(0,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[0]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[0] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[0].x = 703.8;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[0].y = 569.1;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[0].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[0].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[0].onLayout) compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[0].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[1] && compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[1] = compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory(1,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[1]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[1] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[1].x = 703.8;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[1].y = 519.2;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[1].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[1].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[1].onLayout) compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[1].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[2] && compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[2] = compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory(2,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[2]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[2] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[2].x = 703.8;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[2].y = 468.65;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[2].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[2].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[2].onLayout) compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[2].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[3] && compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[3] = compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory(3,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[3]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[3] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[3].x = 703.8;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[3].y = 418.6;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[3].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[3].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[3].onLayout) compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[3].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[4] && compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[4] = compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory(4,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[4]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[4] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[4].x = 703.8;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[4].y = 569.1;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[4].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[4].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[4].onLayout) compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[4].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[5] && compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[5] = compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory(5,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[5]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[5] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[5].x = 703.8;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[5].y = 519.2;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[5].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[5].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[5].onLayout) compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[5].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[6] && compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[6] = compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory(6,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[6]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[6] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[6].x = 703.8;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[6].y = 468.65;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[6].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[6].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[6].onLayout) compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[6].onLayout();
	}
	if (!compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[7] && compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory) {
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[7] = compareGraphPictoGraphPondTwoStressorsBarThreeIconBg.elementFactory(7,undefined);
	}
	if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[7]) {
		RestStopGameLayout_compareGraphPictoGraphIConBg.call(compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[7] as IRestStopGameLayout_compareGraphPictoGraphIConBg);
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[7].x = 703.8;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[7].y = 418.6;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[7].width = 46.50;
		compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[7].height = 49.00;
		if (compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[7].onLayout) compareGraphPictoGraphPondTwoStressorsBarThreeIconBg[7].onLayout();
	}
	const compareGraphPictographBg = this.compareGraphPictographBg;
	if (!compareGraphPictographBg[0] && compareGraphPictographBg.elementFactory) {
		compareGraphPictographBg[0] = compareGraphPictographBg.elementFactory(0,undefined);
	}
	if (compareGraphPictographBg[0]) {
		RestStopGameLayout_compareGraphPictographBg.call(compareGraphPictographBg[0] as IRestStopGameLayout_compareGraphPictographBg);
		compareGraphPictographBg[0].x = 281.2;
		compareGraphPictographBg[0].y = 492.3;
		compareGraphPictographBg[0].width = 443.00;
		compareGraphPictographBg[0].height = 230.00;
		if (compareGraphPictographBg[0].onLayout) compareGraphPictographBg[0].onLayout();
	}
	if (!compareGraphPictographBg[1] && compareGraphPictographBg.elementFactory) {
		compareGraphPictographBg[1] = compareGraphPictographBg.elementFactory(1,undefined);
	}
	if (compareGraphPictographBg[1]) {
		RestStopGameLayout_compareGraphPictographBg.call(compareGraphPictographBg[1] as IRestStopGameLayout_compareGraphPictographBg);
		compareGraphPictographBg[1].x = 749.2;
		compareGraphPictographBg[1].y = 492.3;
		compareGraphPictographBg[1].width = 443.00;
		compareGraphPictographBg[1].height = 230.00;
		if (compareGraphPictographBg[1].onLayout) compareGraphPictographBg[1].onLayout();
	}
	const compareGraphBarGraphStressorBar = this.compareGraphBarGraphStressorBar;
	if (!compareGraphBarGraphStressorBar[0] && compareGraphBarGraphStressorBar.elementFactory) {
		compareGraphBarGraphStressorBar[0] = compareGraphBarGraphStressorBar.elementFactory(0,undefined);
	}
	if (compareGraphBarGraphStressorBar[0]) {
		RestStopGameLayout_compareGraphBarGraphStressorBar0.call(compareGraphBarGraphStressorBar[0] as IRestStopGameLayout_compareGraphBarGraphStressorBar0);
		compareGraphBarGraphStressorBar[0].x = 140.3;
		compareGraphBarGraphStressorBar[0].y = 558.25;
		compareGraphBarGraphStressorBar[0].width = 41.00;
		compareGraphBarGraphStressorBar[0].height = 40.00;
		if (compareGraphBarGraphStressorBar[0].onLayout) compareGraphBarGraphStressorBar[0].onLayout();
	}
	if (!compareGraphBarGraphStressorBar[1] && compareGraphBarGraphStressorBar.elementFactory) {
		compareGraphBarGraphStressorBar[1] = compareGraphBarGraphStressorBar.elementFactory(1,undefined);
	}
	if (compareGraphBarGraphStressorBar[1]) {
		RestStopGameLayout_compareGraphBarGraphStressorBar0.call(compareGraphBarGraphStressorBar[1] as IRestStopGameLayout_compareGraphBarGraphStressorBar0);
		compareGraphBarGraphStressorBar[1].x = 190.8;
		compareGraphBarGraphStressorBar[1].y = 558.45;
		compareGraphBarGraphStressorBar[1].width = 41.00;
		compareGraphBarGraphStressorBar[1].height = 40.00;
		if (compareGraphBarGraphStressorBar[1].onLayout) compareGraphBarGraphStressorBar[1].onLayout();
	}
	if (!compareGraphBarGraphStressorBar[2] && compareGraphBarGraphStressorBar.elementFactory) {
		compareGraphBarGraphStressorBar[2] = compareGraphBarGraphStressorBar.elementFactory(2,undefined);
	}
	if (compareGraphBarGraphStressorBar[2]) {
		RestStopGameLayout_compareGraphBarGraphStressorBar0.call(compareGraphBarGraphStressorBar[2] as IRestStopGameLayout_compareGraphBarGraphStressorBar0);
		compareGraphBarGraphStressorBar[2].x = 241.8;
		compareGraphBarGraphStressorBar[2].y = 558.45;
		compareGraphBarGraphStressorBar[2].width = 41.00;
		compareGraphBarGraphStressorBar[2].height = 40.00;
		if (compareGraphBarGraphStressorBar[2].onLayout) compareGraphBarGraphStressorBar[2].onLayout();
	}
	if (!compareGraphBarGraphStressorBar[3] && compareGraphBarGraphStressorBar.elementFactory) {
		compareGraphBarGraphStressorBar[3] = compareGraphBarGraphStressorBar.elementFactory(3,undefined);
	}
	if (compareGraphBarGraphStressorBar[3]) {
		RestStopGameLayout_compareGraphBarGraphStressorBar0.call(compareGraphBarGraphStressorBar[3] as IRestStopGameLayout_compareGraphBarGraphStressorBar0);
		compareGraphBarGraphStressorBar[3].x = 607.55;
		compareGraphBarGraphStressorBar[3].y = 558.45;
		compareGraphBarGraphStressorBar[3].width = 41.00;
		compareGraphBarGraphStressorBar[3].height = 40.00;
		if (compareGraphBarGraphStressorBar[3].onLayout) compareGraphBarGraphStressorBar[3].onLayout();
	}
	if (!compareGraphBarGraphStressorBar[4] && compareGraphBarGraphStressorBar.elementFactory) {
		compareGraphBarGraphStressorBar[4] = compareGraphBarGraphStressorBar.elementFactory(4,undefined);
	}
	if (compareGraphBarGraphStressorBar[4]) {
		RestStopGameLayout_compareGraphBarGraphStressorBar0.call(compareGraphBarGraphStressorBar[4] as IRestStopGameLayout_compareGraphBarGraphStressorBar0);
		compareGraphBarGraphStressorBar[4].x = 657.95;
		compareGraphBarGraphStressorBar[4].y = 558.45;
		compareGraphBarGraphStressorBar[4].width = 41.00;
		compareGraphBarGraphStressorBar[4].height = 40.00;
		if (compareGraphBarGraphStressorBar[4].onLayout) compareGraphBarGraphStressorBar[4].onLayout();
	}
	if (!compareGraphBarGraphStressorBar[5] && compareGraphBarGraphStressorBar.elementFactory) {
		compareGraphBarGraphStressorBar[5] = compareGraphBarGraphStressorBar.elementFactory(5,undefined);
	}
	if (compareGraphBarGraphStressorBar[5]) {
		RestStopGameLayout_compareGraphBarGraphStressorBar0.call(compareGraphBarGraphStressorBar[5] as IRestStopGameLayout_compareGraphBarGraphStressorBar0);
		compareGraphBarGraphStressorBar[5].x = 709.7;
		compareGraphBarGraphStressorBar[5].y = 558.45;
		compareGraphBarGraphStressorBar[5].width = 41.00;
		compareGraphBarGraphStressorBar[5].height = 40.00;
		if (compareGraphBarGraphStressorBar[5].onLayout) compareGraphBarGraphStressorBar[5].onLayout();
	}
	const compareGraphBarGraphResourceBar = this.compareGraphBarGraphResourceBar;
	if (!compareGraphBarGraphResourceBar[0] && compareGraphBarGraphResourceBar.elementFactory) {
		compareGraphBarGraphResourceBar[0] = compareGraphBarGraphResourceBar.elementFactory(0,undefined);
	}
	if (compareGraphBarGraphResourceBar[0]) {
		RestStopGameLayout_compareGraphBarGraphResourceBar0.call(compareGraphBarGraphResourceBar[0] as IRestStopGameLayout_compareGraphBarGraphResourceBar0);
		compareGraphBarGraphResourceBar[0].x = 354.3;
		compareGraphBarGraphResourceBar[0].y = 558.45;
		compareGraphBarGraphResourceBar[0].width = 41.00;
		compareGraphBarGraphResourceBar[0].height = 40.00;
		if (compareGraphBarGraphResourceBar[0].onLayout) compareGraphBarGraphResourceBar[0].onLayout();
	}
	if (!compareGraphBarGraphResourceBar[1] && compareGraphBarGraphResourceBar.elementFactory) {
		compareGraphBarGraphResourceBar[1] = compareGraphBarGraphResourceBar.elementFactory(1,undefined);
	}
	if (compareGraphBarGraphResourceBar[1]) {
		RestStopGameLayout_compareGraphBarGraphResourceBar0.call(compareGraphBarGraphResourceBar[1] as IRestStopGameLayout_compareGraphBarGraphResourceBar0);
		compareGraphBarGraphResourceBar[1].x = 405;
		compareGraphBarGraphResourceBar[1].y = 558.45;
		compareGraphBarGraphResourceBar[1].width = 41.00;
		compareGraphBarGraphResourceBar[1].height = 40.00;
		if (compareGraphBarGraphResourceBar[1].onLayout) compareGraphBarGraphResourceBar[1].onLayout();
	}
	if (!compareGraphBarGraphResourceBar[2] && compareGraphBarGraphResourceBar.elementFactory) {
		compareGraphBarGraphResourceBar[2] = compareGraphBarGraphResourceBar.elementFactory(2,undefined);
	}
	if (compareGraphBarGraphResourceBar[2]) {
		RestStopGameLayout_compareGraphBarGraphResourceBar0.call(compareGraphBarGraphResourceBar[2] as IRestStopGameLayout_compareGraphBarGraphResourceBar0);
		compareGraphBarGraphResourceBar[2].x = 456.3;
		compareGraphBarGraphResourceBar[2].y = 558.45;
		compareGraphBarGraphResourceBar[2].width = 41.00;
		compareGraphBarGraphResourceBar[2].height = 40.00;
		if (compareGraphBarGraphResourceBar[2].onLayout) compareGraphBarGraphResourceBar[2].onLayout();
	}
	if (!compareGraphBarGraphResourceBar[3] && compareGraphBarGraphResourceBar.elementFactory) {
		compareGraphBarGraphResourceBar[3] = compareGraphBarGraphResourceBar.elementFactory(3,undefined);
	}
	if (compareGraphBarGraphResourceBar[3]) {
		RestStopGameLayout_compareGraphBarGraphResourceBar0.call(compareGraphBarGraphResourceBar[3] as IRestStopGameLayout_compareGraphBarGraphResourceBar0);
		compareGraphBarGraphResourceBar[3].x = 821.95;
		compareGraphBarGraphResourceBar[3].y = 558.45;
		compareGraphBarGraphResourceBar[3].width = 41.00;
		compareGraphBarGraphResourceBar[3].height = 40.00;
		if (compareGraphBarGraphResourceBar[3].onLayout) compareGraphBarGraphResourceBar[3].onLayout();
	}
	if (!compareGraphBarGraphResourceBar[4] && compareGraphBarGraphResourceBar.elementFactory) {
		compareGraphBarGraphResourceBar[4] = compareGraphBarGraphResourceBar.elementFactory(4,undefined);
	}
	if (compareGraphBarGraphResourceBar[4]) {
		RestStopGameLayout_compareGraphBarGraphResourceBar0.call(compareGraphBarGraphResourceBar[4] as IRestStopGameLayout_compareGraphBarGraphResourceBar0);
		compareGraphBarGraphResourceBar[4].x = 872.55;
		compareGraphBarGraphResourceBar[4].y = 558.45;
		compareGraphBarGraphResourceBar[4].width = 41.00;
		compareGraphBarGraphResourceBar[4].height = 40.00;
		if (compareGraphBarGraphResourceBar[4].onLayout) compareGraphBarGraphResourceBar[4].onLayout();
	}
	if (!compareGraphBarGraphResourceBar[5] && compareGraphBarGraphResourceBar.elementFactory) {
		compareGraphBarGraphResourceBar[5] = compareGraphBarGraphResourceBar.elementFactory(5,undefined);
	}
	if (compareGraphBarGraphResourceBar[5]) {
		RestStopGameLayout_compareGraphBarGraphResourceBar0.call(compareGraphBarGraphResourceBar[5] as IRestStopGameLayout_compareGraphBarGraphResourceBar0);
		compareGraphBarGraphResourceBar[5].x = 924.2;
		compareGraphBarGraphResourceBar[5].y = 558.45;
		compareGraphBarGraphResourceBar[5].width = 41.00;
		compareGraphBarGraphResourceBar[5].height = 40.00;
		if (compareGraphBarGraphResourceBar[5].onLayout) compareGraphBarGraphResourceBar[5].onLayout();
	}
	const compareGraphBarGraphStressorsXAxisIcon = this.compareGraphBarGraphStressorsXAxisIcon;
	if (!compareGraphBarGraphStressorsXAxisIcon[0] && compareGraphBarGraphStressorsXAxisIcon.elementFactory) {
		compareGraphBarGraphStressorsXAxisIcon[0] = compareGraphBarGraphStressorsXAxisIcon.elementFactory(0,undefined);
	}
	if (compareGraphBarGraphStressorsXAxisIcon[0]) {
		RestStopGameLayout_compareGraphBarGraphIconBg.call(compareGraphBarGraphStressorsXAxisIcon[0] as IRestStopGameLayout_compareGraphBarGraphIconBg);
		compareGraphBarGraphStressorsXAxisIcon[0].x = 140.3;
		compareGraphBarGraphStressorsXAxisIcon[0].y = 580;
		compareGraphBarGraphStressorsXAxisIcon[0].width = 45.00;
		compareGraphBarGraphStressorsXAxisIcon[0].height = 35.00;
		if (compareGraphBarGraphStressorsXAxisIcon[0].onLayout) compareGraphBarGraphStressorsXAxisIcon[0].onLayout();
	}
	if (!compareGraphBarGraphStressorsXAxisIcon[1] && compareGraphBarGraphStressorsXAxisIcon.elementFactory) {
		compareGraphBarGraphStressorsXAxisIcon[1] = compareGraphBarGraphStressorsXAxisIcon.elementFactory(1,undefined);
	}
	if (compareGraphBarGraphStressorsXAxisIcon[1]) {
		RestStopGameLayout_compareGraphBarGraphIconBg.call(compareGraphBarGraphStressorsXAxisIcon[1] as IRestStopGameLayout_compareGraphBarGraphIconBg);
		compareGraphBarGraphStressorsXAxisIcon[1].x = 190.3;
		compareGraphBarGraphStressorsXAxisIcon[1].y = 580;
		compareGraphBarGraphStressorsXAxisIcon[1].width = 45.00;
		compareGraphBarGraphStressorsXAxisIcon[1].height = 35.00;
		if (compareGraphBarGraphStressorsXAxisIcon[1].onLayout) compareGraphBarGraphStressorsXAxisIcon[1].onLayout();
	}
	if (!compareGraphBarGraphStressorsXAxisIcon[2] && compareGraphBarGraphStressorsXAxisIcon.elementFactory) {
		compareGraphBarGraphStressorsXAxisIcon[2] = compareGraphBarGraphStressorsXAxisIcon.elementFactory(2,undefined);
	}
	if (compareGraphBarGraphStressorsXAxisIcon[2]) {
		RestStopGameLayout_compareGraphBarGraphIconBg.call(compareGraphBarGraphStressorsXAxisIcon[2] as IRestStopGameLayout_compareGraphBarGraphIconBg);
		compareGraphBarGraphStressorsXAxisIcon[2].x = 242.65;
		compareGraphBarGraphStressorsXAxisIcon[2].y = 580;
		compareGraphBarGraphStressorsXAxisIcon[2].width = 45.00;
		compareGraphBarGraphStressorsXAxisIcon[2].height = 35.00;
		if (compareGraphBarGraphStressorsXAxisIcon[2].onLayout) compareGraphBarGraphStressorsXAxisIcon[2].onLayout();
	}
	if (!compareGraphBarGraphStressorsXAxisIcon[3] && compareGraphBarGraphStressorsXAxisIcon.elementFactory) {
		compareGraphBarGraphStressorsXAxisIcon[3] = compareGraphBarGraphStressorsXAxisIcon.elementFactory(3,undefined);
	}
	if (compareGraphBarGraphStressorsXAxisIcon[3]) {
		RestStopGameLayout_compareGraphBarGraphIconBg.call(compareGraphBarGraphStressorsXAxisIcon[3] as IRestStopGameLayout_compareGraphBarGraphIconBg);
		compareGraphBarGraphStressorsXAxisIcon[3].x = 607.15;
		compareGraphBarGraphStressorsXAxisIcon[3].y = 580;
		compareGraphBarGraphStressorsXAxisIcon[3].width = 45.00;
		compareGraphBarGraphStressorsXAxisIcon[3].height = 35.00;
		if (compareGraphBarGraphStressorsXAxisIcon[3].onLayout) compareGraphBarGraphStressorsXAxisIcon[3].onLayout();
	}
	if (!compareGraphBarGraphStressorsXAxisIcon[4] && compareGraphBarGraphStressorsXAxisIcon.elementFactory) {
		compareGraphBarGraphStressorsXAxisIcon[4] = compareGraphBarGraphStressorsXAxisIcon.elementFactory(4,undefined);
	}
	if (compareGraphBarGraphStressorsXAxisIcon[4]) {
		RestStopGameLayout_compareGraphBarGraphIconBg.call(compareGraphBarGraphStressorsXAxisIcon[4] as IRestStopGameLayout_compareGraphBarGraphIconBg);
		compareGraphBarGraphStressorsXAxisIcon[4].x = 657.45;
		compareGraphBarGraphStressorsXAxisIcon[4].y = 580;
		compareGraphBarGraphStressorsXAxisIcon[4].width = 45.00;
		compareGraphBarGraphStressorsXAxisIcon[4].height = 35.00;
		if (compareGraphBarGraphStressorsXAxisIcon[4].onLayout) compareGraphBarGraphStressorsXAxisIcon[4].onLayout();
	}
	if (!compareGraphBarGraphStressorsXAxisIcon[5] && compareGraphBarGraphStressorsXAxisIcon.elementFactory) {
		compareGraphBarGraphStressorsXAxisIcon[5] = compareGraphBarGraphStressorsXAxisIcon.elementFactory(5,undefined);
	}
	if (compareGraphBarGraphStressorsXAxisIcon[5]) {
		RestStopGameLayout_compareGraphBarGraphIconBg.call(compareGraphBarGraphStressorsXAxisIcon[5] as IRestStopGameLayout_compareGraphBarGraphIconBg);
		compareGraphBarGraphStressorsXAxisIcon[5].x = 709.55;
		compareGraphBarGraphStressorsXAxisIcon[5].y = 580;
		compareGraphBarGraphStressorsXAxisIcon[5].width = 45.00;
		compareGraphBarGraphStressorsXAxisIcon[5].height = 35.00;
		if (compareGraphBarGraphStressorsXAxisIcon[5].onLayout) compareGraphBarGraphStressorsXAxisIcon[5].onLayout();
	}
	const compareGraphBarGraphResourcesXAxisIcon = this.compareGraphBarGraphResourcesXAxisIcon;
	if (!compareGraphBarGraphResourcesXAxisIcon[0] && compareGraphBarGraphResourcesXAxisIcon.elementFactory) {
		compareGraphBarGraphResourcesXAxisIcon[0] = compareGraphBarGraphResourcesXAxisIcon.elementFactory(0,undefined);
	}
	if (compareGraphBarGraphResourcesXAxisIcon[0]) {
		RestStopGameLayout_compareGraphBarGraphIconBg.call(compareGraphBarGraphResourcesXAxisIcon[0] as IRestStopGameLayout_compareGraphBarGraphIconBg);
		compareGraphBarGraphResourcesXAxisIcon[0].x = 353.75;
		compareGraphBarGraphResourcesXAxisIcon[0].y = 580;
		compareGraphBarGraphResourcesXAxisIcon[0].width = 45.00;
		compareGraphBarGraphResourcesXAxisIcon[0].height = 35.00;
		if (compareGraphBarGraphResourcesXAxisIcon[0].onLayout) compareGraphBarGraphResourcesXAxisIcon[0].onLayout();
	}
	if (!compareGraphBarGraphResourcesXAxisIcon[1] && compareGraphBarGraphResourcesXAxisIcon.elementFactory) {
		compareGraphBarGraphResourcesXAxisIcon[1] = compareGraphBarGraphResourcesXAxisIcon.elementFactory(1,undefined);
	}
	if (compareGraphBarGraphResourcesXAxisIcon[1]) {
		RestStopGameLayout_compareGraphBarGraphIconBg.call(compareGraphBarGraphResourcesXAxisIcon[1] as IRestStopGameLayout_compareGraphBarGraphIconBg);
		compareGraphBarGraphResourcesXAxisIcon[1].x = 404.45;
		compareGraphBarGraphResourcesXAxisIcon[1].y = 580;
		compareGraphBarGraphResourcesXAxisIcon[1].width = 45.00;
		compareGraphBarGraphResourcesXAxisIcon[1].height = 35.00;
		if (compareGraphBarGraphResourcesXAxisIcon[1].onLayout) compareGraphBarGraphResourcesXAxisIcon[1].onLayout();
	}
	if (!compareGraphBarGraphResourcesXAxisIcon[2] && compareGraphBarGraphResourcesXAxisIcon.elementFactory) {
		compareGraphBarGraphResourcesXAxisIcon[2] = compareGraphBarGraphResourcesXAxisIcon.elementFactory(2,undefined);
	}
	if (compareGraphBarGraphResourcesXAxisIcon[2]) {
		RestStopGameLayout_compareGraphBarGraphIconBg.call(compareGraphBarGraphResourcesXAxisIcon[2] as IRestStopGameLayout_compareGraphBarGraphIconBg);
		compareGraphBarGraphResourcesXAxisIcon[2].x = 456.95;
		compareGraphBarGraphResourcesXAxisIcon[2].y = 580;
		compareGraphBarGraphResourcesXAxisIcon[2].width = 45.00;
		compareGraphBarGraphResourcesXAxisIcon[2].height = 35.00;
		if (compareGraphBarGraphResourcesXAxisIcon[2].onLayout) compareGraphBarGraphResourcesXAxisIcon[2].onLayout();
	}
	if (!compareGraphBarGraphResourcesXAxisIcon[3] && compareGraphBarGraphResourcesXAxisIcon.elementFactory) {
		compareGraphBarGraphResourcesXAxisIcon[3] = compareGraphBarGraphResourcesXAxisIcon.elementFactory(3,undefined);
	}
	if (compareGraphBarGraphResourcesXAxisIcon[3]) {
		RestStopGameLayout_compareGraphBarGraphIconBg.call(compareGraphBarGraphResourcesXAxisIcon[3] as IRestStopGameLayout_compareGraphBarGraphIconBg);
		compareGraphBarGraphResourcesXAxisIcon[3].x = 821.65;
		compareGraphBarGraphResourcesXAxisIcon[3].y = 580;
		compareGraphBarGraphResourcesXAxisIcon[3].width = 45.00;
		compareGraphBarGraphResourcesXAxisIcon[3].height = 35.00;
		if (compareGraphBarGraphResourcesXAxisIcon[3].onLayout) compareGraphBarGraphResourcesXAxisIcon[3].onLayout();
	}
	if (!compareGraphBarGraphResourcesXAxisIcon[4] && compareGraphBarGraphResourcesXAxisIcon.elementFactory) {
		compareGraphBarGraphResourcesXAxisIcon[4] = compareGraphBarGraphResourcesXAxisIcon.elementFactory(4,undefined);
	}
	if (compareGraphBarGraphResourcesXAxisIcon[4]) {
		RestStopGameLayout_compareGraphBarGraphIconBg.call(compareGraphBarGraphResourcesXAxisIcon[4] as IRestStopGameLayout_compareGraphBarGraphIconBg);
		compareGraphBarGraphResourcesXAxisIcon[4].x = 871.35;
		compareGraphBarGraphResourcesXAxisIcon[4].y = 580;
		compareGraphBarGraphResourcesXAxisIcon[4].width = 45.00;
		compareGraphBarGraphResourcesXAxisIcon[4].height = 35.00;
		if (compareGraphBarGraphResourcesXAxisIcon[4].onLayout) compareGraphBarGraphResourcesXAxisIcon[4].onLayout();
	}
	if (!compareGraphBarGraphResourcesXAxisIcon[5] && compareGraphBarGraphResourcesXAxisIcon.elementFactory) {
		compareGraphBarGraphResourcesXAxisIcon[5] = compareGraphBarGraphResourcesXAxisIcon.elementFactory(5,undefined);
	}
	if (compareGraphBarGraphResourcesXAxisIcon[5]) {
		RestStopGameLayout_compareGraphBarGraphIconBg.call(compareGraphBarGraphResourcesXAxisIcon[5] as IRestStopGameLayout_compareGraphBarGraphIconBg);
		compareGraphBarGraphResourcesXAxisIcon[5].x = 924.35;
		compareGraphBarGraphResourcesXAxisIcon[5].y = 580;
		compareGraphBarGraphResourcesXAxisIcon[5].width = 45.00;
		compareGraphBarGraphResourcesXAxisIcon[5].height = 35.00;
		if (compareGraphBarGraphResourcesXAxisIcon[5].onLayout) compareGraphBarGraphResourcesXAxisIcon[5].onLayout();
	}
	const compareGraphBargraphBg = this.compareGraphBargraphBg;
	if (!compareGraphBargraphBg[0] && compareGraphBargraphBg.elementFactory) {
		compareGraphBargraphBg[0] = compareGraphBargraphBg.elementFactory(0,undefined);
	}
	if (compareGraphBargraphBg[0]) {
		RestStopGameLayout_compareGraphBargraphBg.call(compareGraphBargraphBg[0] as IRestStopGameLayout_compareGraphBargraphBg);
		compareGraphBargraphBg[0].x = 281.2;
		compareGraphBargraphBg[0].y = 492.3;
		compareGraphBargraphBg[0].width = 443.00;
		compareGraphBargraphBg[0].height = 230.00;
		if (compareGraphBargraphBg[0].onLayout) compareGraphBargraphBg[0].onLayout();
	}
	if (!compareGraphBargraphBg[1] && compareGraphBargraphBg.elementFactory) {
		compareGraphBargraphBg[1] = compareGraphBargraphBg.elementFactory(1,undefined);
	}
	if (compareGraphBargraphBg[1]) {
		RestStopGameLayout_compareGraphBargraphBg.call(compareGraphBargraphBg[1] as IRestStopGameLayout_compareGraphBargraphBg);
		compareGraphBargraphBg[1].x = 749.2;
		compareGraphBargraphBg[1].y = 492.3;
		compareGraphBargraphBg[1].width = 443.00;
		compareGraphBargraphBg[1].height = 230.00;
		if (compareGraphBargraphBg[1].onLayout) compareGraphBargraphBg[1].onLayout();
	}
	if (!compareGraphBargraphBg[2] && compareGraphBargraphBg.elementFactory) {
		compareGraphBargraphBg[2] = compareGraphBargraphBg.elementFactory(2,undefined);
	}
	if (compareGraphBargraphBg[2]) {
		RestStopGameLayout_compareGraphBargraphBg.call(compareGraphBargraphBg[2] as IRestStopGameLayout_compareGraphBargraphBg);
		compareGraphBargraphBg[2].x = 281.2;
		compareGraphBargraphBg[2].y = 492.3;
		compareGraphBargraphBg[2].width = 443.00;
		compareGraphBargraphBg[2].height = 230.00;
		if (compareGraphBargraphBg[2].onLayout) compareGraphBargraphBg[2].onLayout();
	}
	const bg = this.bg;
	RestStopGameLayout_bg.call(this.bg);
	bg.x = 512;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const barGraphButton = this.barGraphButton;
	RestStopGameLayout_barGraphButton.call(this.barGraphButton);
	barGraphButton.x = 602.25;
	barGraphButton.y = 684.75;
	barGraphButton.width = 151.50;
	barGraphButton.height = 95.50;
	if (barGraphButton.onLayout) barGraphButton.onLayout();
	const pictoGraphButton = this.pictoGraphButton;
	RestStopGameLayout_pictoGraphButton.call(this.pictoGraphButton);
	pictoGraphButton.x = 393.2;
	pictoGraphButton.y = 684.75;
	pictoGraphButton.width = 151.50;
	pictoGraphButton.height = 95.50;
	if (pictoGraphButton.onLayout) pictoGraphButton.onLayout();
	const barGraphBg = this.barGraphBg;
	RestStopGameLayout_barGraphBg.call(this.barGraphBg);
	barGraphBg.x = 797.5;
	barGraphBg.y = 413.45;
	barGraphBg.width = 390.00;
	barGraphBg.height = 374.95;
	if (barGraphBg.onLayout) barGraphBg.onLayout();
	const barGraphTitleBg = this.barGraphTitleBg;
	RestStopGameLayout_graphTitleBg.call(this.barGraphTitleBg);
	barGraphTitleBg.x = 798.05;
	barGraphTitleBg.y = 204.95;
	barGraphTitleBg.width = 177.00;
	barGraphTitleBg.height = 45.00;
	if (barGraphTitleBg.onLayout) barGraphTitleBg.onLayout();
	const pictoGraphBg = this.pictoGraphBg;
	RestStopGameLayout_pictoGraphBg.call(this.pictoGraphBg);
	pictoGraphBg.x = 797.05;
	pictoGraphBg.y = 412.95;
	pictoGraphBg.width = 310.00;
	pictoGraphBg.height = 375.00;
	if (pictoGraphBg.onLayout) pictoGraphBg.onLayout();
	const pictoGraphTitleBg = this.pictoGraphTitleBg;
	RestStopGameLayout_graphTitleBg.call(this.pictoGraphTitleBg);
	pictoGraphTitleBg.x = 798.05;
	pictoGraphTitleBg.y = 204.95;
	pictoGraphTitleBg.width = 177.00;
	pictoGraphTitleBg.height = 45.00;
	if (pictoGraphTitleBg.onLayout) pictoGraphTitleBg.onLayout();
	return this;
}
function RestStopGameLayout_bg(this: IRestStopGameLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-bg@2x.png", 0.500, 0.500);
	return this;
}
function RestStopGameLayout_barGraphButton(this: IRestStopGameLayout_barGraphButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-tally-btn-bar.png", 0.403, 0.503);
	return this;
}
function RestStopGameLayout_pictoGraphButton(this: IRestStopGameLayout_pictoGraphButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-tally-btn-picto.png", 0.403, 0.503);
	return this;
}
function RestStopGameLayout_barGraphBg(this: IRestStopGameLayout_barGraphBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-tally-bar-bg.png", 0.500, 0.500);
	return this;
}
function RestStopGameLayout_graphTitleBg(this: IRestStopGameLayout_graphTitleBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-tally-titlebg.png", 0.503, 0.500);
	return this;
}
function RestStopGameLayout_plusButton(this: IRestStopGameLayout_plusButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-tally-btn-plus.png", 0.500, 0.500);
	return this;
}
function RestStopGameLayout_resourcesBarGraphBar(this: IRestStopGameLayout_resourcesBarGraphBar) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-tally-bar-1high.png", 0.511, 1.000);
	return this;
}
function RestStopGameLayout_stressorsBarGraphBar(this: IRestStopGameLayout_stressorsBarGraphBar) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-tally-bar-1high.png", 0.500, 1.000);
	return this;
}
function RestStopGameLayout_barGraphXAxisIcon(this: IRestStopGameLayout_barGraphXAxisIcon) {
	return this;
}
function RestStopGameLayout_pictoGraphBg(this: IRestStopGameLayout_pictoGraphBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-tally-picto-bg.png", 0.500, 0.500);
	return this;
}
function RestStopGameLayout_pictoGraphIconBg(this: IRestStopGameLayout_pictoGraphIconBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-pictograph-icon-container.png", 0.500, 0.500);
	return this;
}
function RestStopGameLayout_pictoGraphXAxisIcon(this: IRestStopGameLayout_pictoGraphXAxisIcon) {
	return this;
}
function RestStopGameLayout_compareGraphTitleBg(this: IRestStopGameLayout_compareGraphTitleBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-comp-title-bg.png", 0.503, 0.500);
	return this;
}
function RestStopGameLayout_sadFace0(this: IRestStopGameLayout_sadFace0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-comp-title-sadface.png", 0.500, 0.500);
	return this;
}
function RestStopGameLayout_happyFace0(this: IRestStopGameLayout_happyFace0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-comp-title-happyface.png", 0.500, 0.500);
	return this;
}
function RestStopGameLayout_comparePondTitleBg(this: IRestStopGameLayout_comparePondTitleBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-comp-pondtitlebg.png", 0.500, 0.500);
	return this;
}
function RestStopGameLayout_compareGraphPictoGraphIConBg(this: IRestStopGameLayout_compareGraphPictoGraphIConBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-comp-pictograph-icon-container.png", 0.548, 0.520);
	return this;
}
function RestStopGameLayout_compareGraphPictographBg(this: IRestStopGameLayout_compareGraphPictographBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-comp-picto-bg.png", 0.501, 0.500);
	return this;
}
function RestStopGameLayout_compareGraphBarGraphStressorBar0(this: IRestStopGameLayout_compareGraphBarGraphStressorBar0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-comp-bar-1high.png", 0.500, 1.000);
	return this;
}
function RestStopGameLayout_compareGraphBarGraphResourceBar0(this: IRestStopGameLayout_compareGraphBarGraphResourceBar0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-comp-bar-1high.png", 0.500, 1.000);
	return this;
}
function RestStopGameLayout_compareGraphBarGraphIconBg(this: IRestStopGameLayout_compareGraphBarGraphIconBg) {
	return this;
}
function RestStopGameLayout_compareGraphBargraphBg(this: IRestStopGameLayout_compareGraphBargraphBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-reststop-comp-bar-bg.png", 0.501, 0.500);
	return this;
}
interface IRestStopGameLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IRestStopGameLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IRestStopGameLayoutSprite extends IRestStopGameLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IRestStopGameLayoutText extends IRestStopGameLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IRestStopGameLayoutPolygon extends Array<number> {
}
interface IRestStopGameLayout {
	readonly barGraphPlusButton: IRestStopGameLayoutArray<IRestStopGameLayout_plusButton>;
	readonly resourcesBarGraphBar: IRestStopGameLayoutArray<IRestStopGameLayout_resourcesBarGraphBar>;
	readonly stressorsBarGraphBar: IRestStopGameLayoutArray<IRestStopGameLayout_stressorsBarGraphBar>;
	readonly barGraphXAxisIcon: IRestStopGameLayoutArray<IRestStopGameLayout_barGraphXAxisIcon>;
	readonly pictoGraphPlusButton: IRestStopGameLayoutArray<IRestStopGameLayout_plusButton>;
	readonly pictoGraphColumnOneIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_pictoGraphIconBg>;
	readonly pictoGraphColumnTwoIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_pictoGraphIconBg>;
	readonly pictoGraphColumnThreeIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_pictoGraphIconBg>;
	readonly pictoGraphXAxisIcon: IRestStopGameLayoutArray<IRestStopGameLayout_pictoGraphXAxisIcon>;
	readonly compareGraphStressorsTitleBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphTitleBg>;
	readonly compareGraphResourcesTitleBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphTitleBg>;
	readonly sadFace: IRestStopGameLayoutArray<IRestStopGameLayout_sadFace0>;
	readonly happyFace: IRestStopGameLayoutArray<IRestStopGameLayout_happyFace0>;
	readonly comparePondTitleBg: IRestStopGameLayoutArray<IRestStopGameLayout_comparePondTitleBg>;
	readonly compareGraphPictoGraphPondOneStressorsBarOneIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictoGraphIConBg>;
	readonly compareGraphPictoGraphPondOneStressorsBarTwoIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictoGraphIConBg>;
	readonly compareGraphPictoGraphPondOneStressorsBarThreeIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictoGraphIConBg>;
	readonly compareGraphPictoGraphPondOneResourcesBarOneIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictoGraphIConBg>;
	readonly compareGraphPictoGraphPondOneResourcesBarTwoIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictoGraphIConBg>;
	readonly compareGraphPictoGraphPondOneResourcesBarThreeIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictoGraphIConBg>;
	readonly compareGraphPictoGraphPondTwoResourcesBarOneIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictoGraphIConBg>;
	readonly compareGraphPictoGraphPondTwoResourcesBarTwoIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictoGraphIConBg>;
	readonly compareGraphPictoGraphPondTwoResourcesBarThreeIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictoGraphIConBg>;
	readonly compareGraphPictoGraphPondTwoStressorsBarOneIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictoGraphIConBg>;
	readonly compareGraphPictoGraphPondTwoStressorsBarTwoIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictoGraphIConBg>;
	readonly compareGraphPictoGraphPondTwoStressorsBarThreeIconBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictoGraphIConBg>;
	readonly compareGraphPictographBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphPictographBg>;
	readonly compareGraphBarGraphStressorBar: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphBarGraphStressorBar0>;
	readonly compareGraphBarGraphResourceBar: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphBarGraphResourceBar0>;
	readonly compareGraphBarGraphStressorsXAxisIcon: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphBarGraphIconBg>;
	readonly compareGraphBarGraphResourcesXAxisIcon: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphBarGraphIconBg>;
	readonly compareGraphBargraphBg: IRestStopGameLayoutArray<IRestStopGameLayout_compareGraphBargraphBg>;
	readonly bg: IRestStopGameLayout_bg;
	readonly barGraphButton: IRestStopGameLayout_barGraphButton;
	readonly pictoGraphButton: IRestStopGameLayout_pictoGraphButton;
	readonly barGraphBg: IRestStopGameLayout_barGraphBg;
	readonly barGraphTitleBg: IRestStopGameLayout_graphTitleBg;
	readonly pictoGraphBg: IRestStopGameLayout_pictoGraphBg;
	readonly pictoGraphTitleBg: IRestStopGameLayout_graphTitleBg;
}
interface IRestStopGameLayout_bg extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_barGraphButton extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_pictoGraphButton extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_barGraphBg extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_graphTitleBg extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_plusButton extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_resourcesBarGraphBar extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_stressorsBarGraphBar extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_barGraphXAxisIcon extends IRestStopGameLayoutContainer {
}
interface IRestStopGameLayout_pictoGraphBg extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_pictoGraphIconBg extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_pictoGraphXAxisIcon extends IRestStopGameLayoutContainer {
}
interface IRestStopGameLayout_compareGraphTitleBg extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_sadFace0 extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_happyFace0 extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_comparePondTitleBg extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_compareGraphPictoGraphIConBg extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_compareGraphPictographBg extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_compareGraphBarGraphStressorBar0 extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_compareGraphBarGraphResourceBar0 extends IRestStopGameLayoutSprite {
}
interface IRestStopGameLayout_compareGraphBarGraphIconBg extends IRestStopGameLayoutContainer {
}
interface IRestStopGameLayout_compareGraphBargraphBg extends IRestStopGameLayoutSprite {
}
